import React from 'react'
import StyledText from '../../components/StyledComponents/StyledText'
import { useTheme } from '../../middleware/ThemeContext'
import moment from 'moment';
import { formatDateDefault } from '../../utils/helper';


export interface IUserName {
    firstName?: string;
    lastName?: string;
}

export interface IContactData {
    createdBy?: IUserName | null;
    account?: IUserName | null;
    createdAt?: Date | null;
    source?: string | null;
    updatedAt?: Date | null;
    lastModifiedBy?: IUserName | null;
}

export interface IAboutUserProps {
    contactData: IContactData;
}

const AboutUser: React.FC<IAboutUserProps> = ({ contactData }) => {
    const { theme } = useTheme();
    return (
        <div className="d-flex flex-column rounded-1">
            <div className="d-flex flex-column gap-1 mt-1">
                <div className='d-flex align-items-center gap-1'>
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme?.colors?.textSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        Created By:

                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme?.colors?.lightSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        {
                            contactData?.createdBy
                                ? `${contactData.createdBy?.firstName} ${contactData.createdBy?.lastName}`
                                : contactData?.account
                                    ? `${contactData.account?.firstName} ${contactData.account?.lastName}`
                                    : ""
                        }
                    </StyledText>
                </div>

                <div className='d-flex align-items-center gap-1'>
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme?.colors?.textSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        Creation Date:

                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme?.colors?.lightSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        {/* {new Date(contactData?.createdAt ?? "").toLocaleDateString(
                            "en-US",
                            {
                                year: "numeric",
                                month: "long",
                                day: "numeric",
                            }
                        )} */}
                        {
                        contactData.createdAt ?
                        formatDateDefault(contactData?.createdAt, true) : '-'
                        }
                    </StyledText>
                </div>

                <div className='d-flex align-items-center gap-1'>
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme?.colors?.textSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        Last Modified By:

                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme?.colors?.lightSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        {
                            contactData?.createdBy
                                ? `${contactData.createdBy?.firstName} ${contactData.createdBy?.lastName}`
                                : contactData?.account
                                    ? `${contactData.account?.firstName} ${contactData.account?.lastName}`
                                    : ""
                        }
                    </StyledText>
                </div>

                <div className='d-flex align-items-center gap-1'>
                    <StyledText
                        fontSize="14px"
                        fontWeight={600}
                        textColor={theme.CorporateTheme?.colors?.textSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        Last Modified Date:

                    </StyledText>
                    <StyledText
                        fontSize="14px"
                        fontWeight={400}
                        textColor={theme.CorporateTheme?.colors?.lightSecondary}
                        style={{ marginBottom: '10px' }}
                    >
                        {
                        contactData?.updatedAt ?
                        formatDateDefault(contactData?.updatedAt, true) : '-'
                        }
                    </StyledText>
                </div>

                {/* <InfoBox theme={theme}>

                    <StyledText
                        fontSize="14px"
                        fontWeight={500}
                        color={theme.CorporateTheme.colors.headerColor}
                        style={{ fontStyle: 'italic' }}
                        htmlTag={'span'}>
                        Source: {contactData?.source}
                    </StyledText>
                </InfoBox> */}
            </div>
        </div>
    )
}

export default AboutUser
